//import { Icon } from '@gplibraries/react/components';
import './PermissionsTable.scss';
import EditUserAction from './EditUserAction';
import { InviteModal } from "../EmployeeUsersInUse/InviteModal";
import { useState } from 'react';
import {LoadingCircle} from '@gplibraries/react/components';


const PERMISSIONS_BY_CODE = {
  "1": "Parts",
  "2": "Wholegoods",
  "3": "Service",
  "4": "Warranty",
  "5": "Sales & Marketing",
  "6": "Credit",
  "9": "Government Contracts",

};

function getLPLabels(user) {
  if (!user.permissionsByDivision?.LP?.enabled) return [];

  const lpCodes = Object.keys(user.permissionsByDivision.LP.codes || {});
  return permissionLabels(lpCodes);
}

function permissionLabels(permissionCodes = []) {
  return permissionCodes.map((code) => PERMISSIONS_BY_CODE[String(code)] ?? String(code));
  }



export default function PermissionsTable({ users: initialUsers, dealer:dealerInfo, onSavePermissions, onDeleteUser, onInviteUser, searchTerm= '', onSearchChange, deletingUser, updatingUser }) {
  const [selectedPerms, setSelectedPerms] = useState([]);
  const [permSelectValue, setPermSelectValue] = useState('');




  const permissionOptions = Object.entries(PERMISSIONS_BY_CODE).map(
    ([code, label]) => ({ code, label })
  );



  //handlers that will eventually make some api call 
  async function handleSaveUser(updatedUser) {
    if (onSavePermissions) {
      return await onSavePermissions?.(updatedUser);
    }
  }
    const [inviteUser, setInviteUser] = useState(null);
    const [inviteOpen, setInviteOpen] = useState(false);

  

  function handleDeleteUser(id) {
    if (onDeleteUser) {
      onDeleteUser?.(id);
    }
  }

  
  const filteredUsers = (initialUsers ?? []).filter((user) => {
    const term = searchTerm.toLowerCase();

    /**  NAME / EMAIL MATCH */
    const nameMatch =
      !term ||
      user.name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term);

    /** PERMISSION MATCH */
    const permissionMatch =
      selectedPerms.length === 0 ||
      selectedPerms.every((p) =>
        user.permissions?.includes(String(p))
      );

    return nameMatch && permissionMatch;
  });


  return (
    <section className="permissions-table-container">
      <div className='permissions-filters'>
        <input
          type="text"
          className='permissions-search'
          placeholder="Search by name or email…"
          value={searchTerm}
          onChange={(e) => onSearchChange?.(e.target.value)}
        />

        <select
        className='permissions-dropdown'
          value={permSelectValue}
          onChange={(e) => {
            const value = e.target.value;
            if (!value) return;

            setSelectedPerms((prev) =>
              prev.includes(value) ? prev : [...prev, value]
            );
            setPermSelectValue('');
          }}
        >
          <option value="">Filter by permission…</option>
          {permissionOptions.map(({ code, label }) => (
            <option key={code} value={code}>
              {label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="invite-btn"
          onClick={() => {
            setInviteUser(null)
            setInviteOpen(true);
          }
          }
        >
          Add User
        </button>
      </div>
      <h3>
          Employee Users for {dealerInfo?.dealer_number} ({dealerInfo?.dealer_name})
        </h3>

      {selectedPerms.length > 0 && (
        <div className="permissions-selected">
          {selectedPerms.map((code) => (
            <span key={code} className="permissions-chip">
              {PERMISSIONS_BY_CODE[code]}
              <button
                className="permissions-chip__remove"
                onClick={() =>
                  setSelectedPerms((prev) => prev.filter((p) => p !== code))
                }
                aria-label={`Remove ${PERMISSIONS_BY_CODE[code]}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}

      <table className="permissions-table">
        <thead>
          <tr>
            <th className="col-user">User</th>
            <th className="col-perms">Permissions</th>
            <th className="col-actions">Actions</th>
          </tr>
        </thead>

        <tbody>   
          {filteredUsers?.map((user) => {
            const labels = getLPLabels(user); 

            return ( 
              <tr key={user.employee_user ?? user.email}>
                <td className="col-user">
                  <span className="name">{user.name}</span>
                  <span className="email">{user.email}</span>
                </td>

                <td className="col-perms">
                  <span className="mobile-only">Permissions:</span>
                  <div className="perm-tags">
                    {labels.length > 0 ? (
                      labels.map((p) => (
                        <span key={p} className="perm-tag">{p}</span>
                      ))
                    ) : (
                      <span className="perm-tag perm-tag--empty">
                        No permissions
                      </span>
                    )}
                  </div>
                </td>

                <td className="col-actions"> 
                  {(deletingUser === user.username || updatingUser === user.employee_user) ? (
                      <LoadingCircle />   //spinner JUST for this row
                    ) : (
                      <EditUserAction
                        user={user}
                        allPermissions={PERMISSIONS_BY_CODE}
                        onSavePermissions={handleSaveUser}
                        onDelete={handleDeleteUser}
                        dealerInfo={dealerInfo}
                      />
                    )}
                </td>
              </tr>
            );
          })}
          {filteredUsers.length === 0 && (
            <tr>
              <td colSpan={3} className="empty-state">
                No employees found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <InviteModal
        user={inviteUser}
        isOpen={inviteOpen}
        onClose={() => {
          setInviteOpen(false);
          setInviteUser(null);
        }}
        onSubmit={(data) => {
          if (onInviteUser) {
            onInviteUser(data);
          }
          setInviteOpen(false);
          setInviteUser(null);
        }}
        mode ="permissions"
        dealerInfo={dealerInfo}
      />
    </section>
  );
}

